import { Props } from "./types"
import styles from './Container.module.scss'
export const Container = (props:Props)=>{
    return <div className={styles.root}>
        {props.children}
    </div>
}